//	Generic way to send a response - always using a payload to encapsulate the response
const respond = (type, payload = {}, meta = {}) => ({ type, payload, meta })

//	Promise response for thunk
const respondPromise = (outerDispatch, type, payload = {}, meta = {}) => new Promise((resolve) => {
	outerDispatch((dispatch, getState, extraArgument) => {
		dispatch(respond(type, payload, meta))
		resolve({ getState, extraArgument })
	})
})

respond.promise = respondPromise

export default respond



// WEBPACK FOOTER //
// ./src/redux/actionCreators/old_actions/utilities/respond.js